export type JpegType = 'progressive' | 'sequential' | 'unknown';

export class JpegChecker {

  private static getJpegType(bytes: ArrayBuffer | Uint8Array): JpegType {
    const u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
    if (u8.length < 4 || u8[0] !== 0xFF || u8[1] !== 0xD8) return 'unknown'; // SOI check

    let i = 2;
    const read16BE = (p: number) => (u8[p] << 8) | u8[p + 1];

    while (i < u8.length) {
      // 次の 0xFF を探す（フィルバイト複数連続も考慮）
      while (i < u8.length && u8[i] !== 0xFF) i++;
      if (i >= u8.length) break;
      i++; // skip 0xFF
      while (i < u8.length && u8[i] === 0xFF) i++; // fill bytes
      if (i >= u8.length) break;

      const marker = u8[i++];

      // SOF系（ここで判定して即返す）
      const isSOF =
        marker === 0xC0 || marker === 0xC1 || marker === 0xC2 || marker === 0xC3 ||
        marker === 0xC5 || marker === 0xC6 || marker === 0xC7 ||
        marker === 0xC9 || marker === 0xCA || marker === 0xCB ||
        marker === 0xCD || marker === 0xCE || marker === 0xCF;

      if (isSOF) {
        // プログレッシブ: SOF2(0xC2) / SOF10(0xCA) / SOF14(0xCE)
        return (marker === 0xC2 || marker === 0xCA || marker === 0xCE)
          ? 'progressive'
          : 'sequential';
      }

      // 長さを持たないスタンドアロン
      if (marker === 0xD8 /* SOI */ || marker === 0xD9 /* EOI */ ||
        (marker >= 0xD0 && marker <= 0xD7) /* RSTn */ || marker === 0x01 /* TEM */) {
        if (marker === 0xD9) break; // EOI 到達
        continue;
      }

      // Start of Scan に入ったら SOF は前に出ているはずなので打ち切り
      if (marker === 0xDA /* SOS */) return 'unknown';

      // セグメント長を読んでスキップ（長さは自身の2バイトを含む）
      if (i + 1 >= u8.length) break;
      const len = read16BE(i);
      if (len < 2) break;
      i += len;
    }

    return 'unknown';
  }

  // ブラウザの File/Blob から
  static async getJpegTypeFromBlob(blob: Blob): Promise<JpegType> {
    const buf = await blob.arrayBuffer();
    return this.getJpegType(buf);
  }

  // 便利ラッパー（true ならプログレッシブ）
  static async isProgressiveJpeg(blob: Blob): Promise<boolean> {
    const type = await this.getJpegTypeFromBlob(blob);
    return  type === 'progressive';
  }

}
